import { Delete, Edit, Email, Link } from '@mui/icons-material'
import { Box, TableRow } from '@mui/material'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import IconButton from 'components/icon-button'
import Page from 'components/page'
import { Table } from 'components/table'
import Wrapper from 'components/wrapper'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React from 'react'
import EditInviteEmailDialog from './edit-invite-email-dialog'
import CustomerListFilter from './filter'
import { useStyles } from './styles'
import useComponent from './use-component'

const headCells: ITableHeadDTO[] = [
  {
    id: 'organization',
    label: 'Nome',
    width: 4,
    type: 'group',
    groupText: {
      title: 'corporateName',
      subTitle: 'federalTaxId',
      reference: 'invCorporateName',
    },
  },
  {
    id: 'status',
    label: 'Status',
    width: 2,
    type: 'boolean',
  },
  {
    id: 'responsibleName',
    label: 'Responsável',
    width: 3,
    type: 'text',
  },
  {
    id: 'responsibleEmail',
    label: 'Email',
    width: 3,
    type: 'text',
  },
]

const CustomerList = () => {
  const classes = useStyles()

  const {
    data,
    user,
    isError,
    label,
    filter,
    page,
    rowsPerPage,
    modalIsOpen,
    columnOrder,
    setFilter,
    setColumnOrder,
    handleClearFilter,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSortChange,
    handleClose,
    handleCloseDelete,
    handleRowClick,
    onCopyInvite,
    onResentInvite,
    onEdit,
    onDelete,
    inviteToEdit,
    inviteEmail,
    isSavingInviteEmail,
    setInviteEmail,
    onEditInviteEmail,
    onCloseInviteEmail,
    onConfirmInviteEmail,
  } = useComponent()

  if (isError) {
    return <div>Error...</div>
  }

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={label.titleHeader}
          actionRoute='/customers/new'
          actionText={label.createButton}
        />
      </Header>

      <Page>
        <Table.Root>
          <Table.Overlay
            isEmpty={data == null}
            isSearch={filter.search.length > 0}
            isLoading={false}
            route='/customers/new'
            emptyRouteText={`Adicionar ${label.singular}`}
            searchRouteText={`Adicionar ${label.singular}`}
            searchMessage={`Nenhum ${label.singular} encontrado, você pode criar um novo ${label.singular} clicando no botão`}
            emptyMessage={`Seja bem-vindo à página de gerenciamento de ${label.plural}. Até o momento, nenhum ${label.singular} foi criado. Para começar, você pode criar um novo ${label.singular} clicando no botão`}
          >
            <Box className={classes.containerTableBox}>
              <CustomerListFilter
                filter={filter}
                onChangeFilter={setFilter}
                onClear={handleClearFilter}
              />
              <Table.Wrapper
                totalRows={0}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
                page={page}
                handleClose={handleClose}
                handleCloseDelete={handleCloseDelete}
                modalIsOpen={modalIsOpen}
              >
                <Table.Header
                  handleSortChange={handleSortChange}
                  setOrder={setColumnOrder}
                  headCells={headCells}
                  order={columnOrder}
                />
                <Table.Body
                  headCells={headCells}
                  rows={data}
                  allowActions
                >
                  {data.map((row) => (
                    <TableRow
                      hover
                      key={Math.random()}
                      sx={{
                        border: '1px solid red',
                        cursor: 'pointer',
                        ':hover': {
                          backgroundColor: 'red',
                        },
                      }}
                      onClick={(event: React.MouseEvent<HTMLTableRowElement, globalThis.MouseEvent>) =>
                        handleRowClick(event, row)
                      }
                    >
                      <Table.RowContent
                        headCells={headCells}
                        data={row}
                      />

                      <Table.Actions>
                        {row.status !== 'Ativo' && (
                          <>
                            {user && user.isSeller && (
                              <IconButton
                                icon={Link}
                                onClick={() => onCopyInvite(row.token as string)}
                                isDisabled={row.token === '' || row.token === null}
                                tooltip='Copiar link de convite'
                              />
                            )}

                            {user && user.isSeller && (
                              <IconButton
                                icon={Email}
                                onClick={() => onResentInvite(row.inviteId as string)}
                                isDisabled={row.status === 'Ativo'}
                                tooltip='Reenviar convite por email'
                              />
                            )}
                          </>
                        )}

                        {user && user.isSeller && (
                          <>
                            {/* Enquanto o convite nao foi aceito nao existe cadastro
                                a editar, so o proprio convite: o lapis abre a troca de
                                e-mail. Depois de Ativo ele volta a levar ao cadastro. */}
                            <IconButton
                              icon={Edit}
                              onClick={() =>
                                row.status === 'Ativo'
                                  ? onEdit(row.id as string)
                                  : onEditInviteEmail(row)
                              }
                              isDisabled={row.status !== 'Ativo' && !row.inviteId}
                              tooltip={
                                row.status === 'Ativo'
                                  ? `Editar ${label.singular}`
                                  : 'Editar e-mail do convite'
                              }
                            />

                            <IconButton
                              icon={Delete}
                              onClick={() => onDelete(row.id as string)}
                              tooltip={`Deletar ${label.singular}`}
                              isWarning
                            />
                          </>
                        )}
                      </Table.Actions>
                    </TableRow>
                  ))}
                </Table.Body>
              </Table.Wrapper>
            </Box>
          </Table.Overlay>
        </Table.Root>

        <EditInviteEmailDialog
          isOpen={inviteToEdit !== null}
          isLoading={isSavingInviteEmail}
          corporateName={inviteToEdit?.corporateName ?? ''}
          currentEmail={inviteToEdit?.responsibleEmail ?? ''}
          email={inviteEmail}
          onChangeEmail={setInviteEmail}
          onClose={onCloseInviteEmail}
          onConfirm={onConfirmInviteEmail}
        />
      </Page>
    </Wrapper>
  )
}

export default CustomerList
